const theme = {
    containerMaxWidth: 1235,
    fontSize: {
        small: '13px',
        default: '16px',
        menuItem: '16px',
        heroTitle: '24px',
        cardHeading: '20px',
        cardTitle: '16px',
        cardDescription: '15px',
        cardAction: '13px',
        settingLabel: '16px',
        settingDescription: '13px',
    },
    lineHeight: {
        small: '18px',
        default: '24px',
        menuItem: '30px',
        heroTitle: '34px',
        cardHeading: '30px',
        cardTitle: '26px',
        cardDescription: '24px',
        cardAction: '20px',
        settingLabel: '26px',
        settingDescription: '23px',
    },
    colors: {
        primary: '#3858E9',
        primaryHover: '#2F48C5',
        success: '#3FB28F',
        danger: '#FF453A',
        textColorDefault: '#97A3B6',
        textColorDark: '#101517',
        textColorGray: '#4B5563',
        textColorLight: '#FFF',
        backgroundColorLight: '#FFF',
        backgroundColorGrey: '#F9FAFB',
        borderColorGray: '#EBEBEF',
        borderColorLightGray: '#F6F6F8',
    }
}

export default theme;